import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-18">
      {items.map((item, index) => <div key={index} className={`border border-earth-200/30 rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'bg-white shadow-md' : 'bg-sand-100/50 hover:bg-sand-100'}`} data-id="element-19">
          <button className="w-full px-6 py-5 text-left flex justify-between items-center gap-4 focus:outline-none" onClick={() => toggleItem(index)} data-id="element-20">
            <span className="font-serif font-medium text-lg text-earth-900" data-id="element-21">
              {item.question}
            </span>
            <ChevronDown className={`w-5 h-5 text-terracotta-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
          </button>

          <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-23">
            <div className="px-6 pb-5 text-earth-800 leading-relaxed" data-id="element-24">
              {item.answer}
            </div>
          </div>
        </div>)}
    </div>;
}